import React, { useState } from "react";
import { motion } from "framer-motion";
import Backdrop from "./Backdrop";
import { X } from "lucide-react";

const slideIn = {
  hidden: { x: "100vh", opacity: 0 },
  visible: {
    x: "0",
    opacity: 1,
    transition: {
      duration: 0.1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: { x: "-100vh", opacity: 0 },
};

const DeleteApplicationModal = ({ deleteFunc, id, handleClose }) => {
  const [confirmText, setConfirmText] = useState("");
  const isDeleteEnabled = confirmText === "DELETE";

  return (
    <Backdrop onClick={handleClose}>
      <motion.div
        className="rounded max-w-lg min-w-sm bg-white dark:bg-wc-gradient dark:text-white bg-cover text-wc-blue
        shadow-md font-sans p-8 flex flex-col gap-4 relative"
        onClick={(e) => {
          if (e) e.stopPropagation();
        }}
        variants={slideIn}
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.5 }}
      >
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white transition-colors"
          aria-label="Close"
        >
          <X size={24} />
        </button>

        <h2 className="text-xl font-semibold">Confirm Deletion</h2>
        <p className="text-sm">
          This action cannot be undone. Type <span className="font-bold">DELETE</span> to confirm.
        </p>

        <input
          type="text"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder='Type "DELETE" to confirm'
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded 
          bg-white dark:bg-gray-800 text-wc-blue dark:text-white 
          focus:outline-none focus:ring-2 focus:ring-red-400"
        />

        <div className="flex gap-2 mt-2">
          <motion.button
            className="flex-1 rounded p-2 bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300 
            hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors flex items-center justify-center h-button"
            onClick={handleClose}
          >
            Cancel
          </motion.button>

          <motion.button
            className={`flex-1 rounded p-2 flex items-center justify-center h-button transition-colors
            ${
              isDeleteEnabled
                ? "bg-red-400 hover:bg-red-500 text-white cursor-pointer"
                : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-500 cursor-not-allowed"
            }`}
            onClick={() => {
              if (isDeleteEnabled) {
                deleteFunc(id);
                handleClose();
              }
            }}
            disabled={!isDeleteEnabled}
          >
            OK
          </motion.button>
        </div>
      </motion.div>
    </Backdrop>
  );
};

export default DeleteApplicationModal;